import { CID } from 'src/app/Model/Types/CID';

export function safeJSONParse(obj: any): any {
  try {
    return JSON.parse(obj);
  } catch {
    return null;
  }
}
/**
 * Makes a deep copy of an object.
 *
 * Any Salesforce object that is deep copied needs to be saturated afterwards
 *
 * @export
 * @template T
 * @param {T} obj
 * @return {*}  {T}
 */
export function deepCopy<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj));
  // return structuredClone(obj); // ! Added as of 2022 but probably not old enough for us to guarantee our customer's browser supports it https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm
}

export function generateCID(): CID {
  return (Math.floor(Math.random() * 1000)).toString();
}
